import React from "react";

const Button = ({ content, color, borderColor, background, img, onClick }) => {
  return (
    <button
      style={{ color, borderColor, background }}
      onClick={onClick}
      className="type-button w-full text-white text-center bg-[#0dcaf0] px-4 py-4 mr-5 mt-2 rounded-full"
    >
      {content}
    </button>
  );
};

export default Button;
